$(function () {
  if (!customElements.get('social-responsibility-tour-guide')) {
    customElements.define(
      'social-responsibility-tour-guide',
      class socialResponsibilityTourGuide extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          // 查找现有的 swiper-container
          const swiperContainer = this.querySelector('.swiper-container');

          if (!swiperContainer) {
            console.error('CustomSwiper: Missing ".swiper-container" element');
            return;
          }

          // 包裹子元素到 swiper-wrapper 中
          const slides = Array.from(swiperContainer.children);
          let swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');

          if (!swiperWrapper) {
            swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper-wrapper');
            slides.forEach((slide) => {
              slide.classList.add('swiper-slide');
              swiperWrapper.appendChild(slide);
            });
            swiperContainer.appendChild(swiperWrapper);
          }

          // 添加分页元素（如果不存在）
          let pagination = swiperContainer.querySelector('.swiper-pagination');
          if (!pagination) {
            pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            swiperContainer.appendChild(pagination);
          }

          // 初始化 Swiper
          new Swiper(swiperContainer, {
            slidesPerView: 4,
            spaceBetween: 32,
            freeMode: true,
            breakpoints: {
              992: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3.2,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
              200: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
            },
          });
          this.jump();
        }
        jump() {
          this.$element = $('.guide-container');
        }
      }
    );
  }
});
